import React, { useEffect, useState } from 'react'
// import { Redirect } from 'react-router-dom'
// import { useParams } from 'react-router-dom'
// import { useQuery, useMutation, useLazyQuery } from '@apollo/react-hooks'
import { inject, observer } from 'mobx-react'
import { useMutation } from '@apollo/react-hooks'
import { toJS } from "mobx"
import {
  Button,
  Tabs,
  Table,
  Empty,
  Image,
  message,
  Space
} from 'antd';
import {
  ControlOutlined,
  IdcardOutlined,
  SaveOutlined,
  CloseCircleOutlined,
  ShoppingCartOutlined,
  PhoneFilled,
  ShoppingOutlined,
  ContactsFilled,
  QuestionCircleOutlined,
  CheckOutlined
} from '@ant-design/icons';

import styled from 'styled-components'
import PerfectScrollbar from 'react-perfect-scrollbar'
// import useAsyncQuery from "../../../../ultils/useAsyncQuery";
// import SearchBoxItem from "../DataTools/SearchBoxItem";
import LiveOrderPanel from "./LiveOrderPanel"
import LiveCustomerForm from './LiveCustomerForm'
import DataSelectModal from '../DataTools/DataSelectModal'
import { EditableCell, EditableRow } from "../EditableCell"
import { price_render, color_render, customer_render } from '../DataTools/DataField'
import { imagePreset, removeVietnameseCharMark, build_search_by_column } from '../../../../ultils/datatableUtils'
import DataTableServices from '../../../../services/datatableServices'
import { useAsyncQuery } from '../../../../ultils'

const { TabPane } = Tabs;
const LiveDetailContainer = styled.div`
  width:100%;
  padding:8px 15px;  
  `

const LiveDetailPanel = ({ datatableStore, liveStore, commonStore, tableId, history }) => {
  const [codeSelect, setCodeSelect] = useState(false)
  const [customerSelect, setCustomerSelect] = useState(false)
  // const [orderProducts, setOrderProducts] = useState(false)
  // let detailData = liveStore.liveOrders.find(item => item.sid === currentRecordId)?.items

  // const findUsers = useAsyncQuery(DataTableServices.GET_COMPANY_USERS())
  // let xx = await findUsers({ company_slug: 'nhaiu' })
  // console.log(`xx`, xx)

  const [createDatarow] = useMutation(DataTableServices.CREATE_DATAROW(), {
    errorPolicy: 'all',
    update(cache, { data }) {
    }
  })

  const [updateManyDataRows] = useMutation(
    DataTableServices.UPDATE_MANY_ROWS(),
    {
      errorPolicy: 'all'
    }
  )


  const saveCurrentOrder = () => {
    let order = toJS(liveStore.currentLiveOrder)
    // row.se = build_search_by_column(row, [{ key: 'code' }, { key: 'match_code' }, { key: 'name' }])
    let r = updateManyDataRows({
      variables: {
        input: {
          data: {
            type: "rowkey",
            rows: [order]
          }
        }
      }
    })
  }

  useEffect(async () => {
    // let xx = await findUsers({ company_slug: 'nhaiu' })
    // console.log(`xx`, xx)
    // console.log(`liveStore.currentCustomerRecord.edit_count`, liveStore.currentCustomerRecord.edit_count)
  }, [liveStore.updateCount, liveStore.currentOrderItems])

  const CodeRender = (value, row, index) => {
    let name = row.name ? row.name : ""
    let price = row.price ? price_render(row?.price) : ""
    let label = (<div>{`-${name} `}<strong>{price}</strong></div>)
    if (row.match_code && row.match_code != row.code)
      label = (<div>{` [${row?.match_code}] ${name} `}<strong>{price}</strong></div>)

    if (liveStore.currentMsgCode === row.code) {
      label = (<mark>{label}</mark>)
    }

    return (
      <div style={{
        display: 'flex',
        flexWrap: 'nowrap'
      }} >
        <AdjustCode
          row={row}
          onCodeClick={() => {
            setCodeSelect({
              code: row.match_code ? row.match_code : row.code,
              index: index,
              ref: row.ref
            })
          }}
        />
        {label}
        {/* {row.ref ? <div>{` [${row.ref.code}]`}&nbsp;{name} {price_render(row.price)}</div> : ""} */}
      </div>
    )
  }

  const QuanityRender = (value, row, index) => {
    let qty = parseInt(value)
    return (
      <div style={{ color: qty > 0 ? "black" : "#FFB9B3" }} >
        {qty}
        {/* {row.ref ? <div>{row.quanity}
        </div> : value} */}
      </div>
    )
  }

  const AutoQtyRender = (value, row, index) => {
    // let qty = parseInt(row.quanity)
    // let qty = 0
    // let customerByCode = liveStore.liveProducts.find(item => item.code === value)?.customers
    // if (customerByCode) {
    //   qty = customerByCode.find(c => c.sid === liveStore.currentCustomerRecord.sid)?.qty
    // }
    let qty = value
    if (!qty) qty = 0
    return (
      <div style={{ color: qty > 0 ? "black" : "#FFB9B3" }} >
        {qty}
        {/* {row.ref ? <div>{row.quanity}
        </div> : value} */}
      </div>
    )
  }

  const RemainQtyRender = (value, row, index) => {
    // let qty = parseInt(row.quanity)
    let qty = 0
    let codeLive = liveStore.liveProducts.find(item => item.code === value)
    if (codeLive) {
      qty = codeLive.remain
    }
    if (!qty) qty = 0
    return (
      <div style={{ color: qty > 0 ? "black" : "#FFB9B3" }} >
        {qty}
      </div>
    )
  }


  // const ActionRender = (value, row, index) => {
  //   return (
  //     <div>
  //       <Button disabled={!liveStore.liveProducts.find((item) => item.code === row.code)} size={'small'}>+<ShoppingCartOutlined /></Button>
  //     </div>
  //   )
  // }


  const AdjustCode = ({ row, onCodeClick }) => {


    // console.log('row z', row)
    let cls = 'noProduct'
    let currentSearchCode = liveStore.currentSearchCode ? liveStore.currentSearchCode.toLowerCase() : false

    if (liveStore.currentMsgCode === row.code || currentSearchCode == row.code.toLowerCase()) {
      cls = 'highLight'
    }
    else {
      // if (liveStore.findRefProduct(row.code, row.match_code)) cls = 'hasProduct']
      let glp = liveStore.getLiveProductByCode(row.code)
      if (glp.sid) {
        cls = 'sp-le'
      } else {
        cls = 'noProduct'
      }
      if (glp.sid && glp.ref) {
        cls = 'sp-chinh'
      }
      if (row.qty == 0) cls = "cannotOrder"
    }


    // let x = liveStore.currentOrderItems.find(item => item.code == row.code)
    // console.log(`x`, x)
    // console.log(`row`, row)
    // const liveIndex = datatableStore.liveProducts.findIndex((item) => (item.code === row.code || (item.match_code === row.code)))
    // if (liveIndex >= 0 && row.code) cls = 'inLive'



    return (
      <div
        className='tagCode'
        onClick={onCodeClick}
      >
        <span className={cls}>{row.code}</span>
      </div>
    )

    // let cls = acode.ref ? 'hasProduct' : 'noProduct'
    // const index = datatableStore.liveProducts.findIndex((item) => item.code === acode.code || (item.match_code === acode.code))
    // if (index >= 0) cls = 'inLive'
    // return (
    //   <div className='tagCode'>
    //     <span className={cls}>{acode.code}</span>
    //   </div>
    // )
  }


  const cellSave = (row) => {
    // console.log(`row`, row)
    // console.log(`row`, row)

    liveStore.updateCartItem(row)
    if (row) {
      saveCurrentOrder()
      // let order = toJS(liveStore.currentLiveOrder)
      // // row.se = build_search_by_column(row, [{ key: 'code' }, { key: 'match_code' }, { key: 'name' }])
      // let r = updateManyDataRows({
      //   variables: {
      //     input: {
      //       data: {
      //         type: "rowkey",
      //         rows: [order]
      //       }
      //     }
      //   }
      // })
    }
  };

  const columns = [
    {
      title: 'Ảnh',
      dataIndex: 'image',
      key: 'image',
      render: (value, row, index) => {
        if (!value) {
          let lp = liveStore.liveProducts.find(item => item.match_code === row.code)
          if (!lp) lp = liveStore.liveProducts.find(item => item.code === row.code)
          if (lp) {
            value = lp.image
          }
        }
        let thumbnail = imagePreset(value, 'xsmall')
        return <Image
          width={40}
          height={40}
          src={thumbnail}
          preview={{
            src: value,
          }}
        // src={row[c.dataIndex] ? row[c.dataIndex] : ""}
        // fallback="data:image/png;base64,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"
        />
      },
      width: 44
    },
    {
      title: 'Sản phẩm',
      dataIndex: 'code',
      key: 'code',
      render: CodeRender,
      width: 'auto'
    },
    {
      title: 'Đặt',
      dataIndex: 'quanity',
      key: 'quanity',
      width: 60,
      render: QuanityRender,
      editable: true,
      onCell: (record) => ({
        record,
        editable: true,
        inputType: 'number',
        dataIndex: 'quanity',
        title: 'Đặt',
        handleSave: cellSave,
      })
    },
    {
      title: 'Chốt',
      dataIndex: 'qty',
      key: 'qty',
      width: 60,
      editable: true,
      render: AutoQtyRender,
      onCell: (record) => ({
        record,
        editable: true,
        inputType: 'number',
        dataIndex: 'qty',
        title: 'Chốt',
        handleSave: cellSave,
      })
    },
    {
      title: 'Dư',
      dataIndex: 'code',
      key: 'remain_qty',
      width: 40,
      render: RemainQtyRender,
    },
    // {
    //   title: '',
    //   dataIndex: 'code',
    //   width: 60,
    //   render: ActionRender
    // },
  ];

  // useEffect(() => {
  //   if (liveStore.refProduct) {
  //     // liveStore.updateLiveOrdersFromLiveProduct(liveStore.currentCustomerRecord.sid)
  //   }
  // }, [liveStore.currentCustomerRecord, liveStore.liveProducts, liveStore.liveOrders])

  useEffect(() => {
    if (liveStore.refProduct && liveStore.liveProducts) {
      liveStore.updateAllLiveOrderFromLiveProduct()
      // liveStore.updateLiveOrdersFromLiveProduct(liveStore.currentCustomerRecord.sid)
    }
  }, [liveStore.liveProducts])

  useEffect(() => {
  }, [liveStore.currentMsgCode, liveStore.currentSearchCode])

  const saveNewCode = (cSelect) => {
    // console.log(`cSelect`, cSelect)
    if (!cSelect) return
    // detailData.items[cSelect.index].ref = toJS(cSelect.ref)
    let op = toJS(liveStore.currentOrderItems)
    // console.log(`op`, op)
    // return
    let dupIndex = op.findIndex(item => item.code === cSelect.code || item.match_code === cSelect.code)
    if (dupIndex > -1 && cSelect.ref) {
      op[dupIndex].match_code = cSelect.ref.code
      op[dupIndex].ref = cSelect.ref.sid
      op[dupIndex].name = cSelect.ref.name
      op[dupIndex].price = cSelect.ref.price_live
      liveStore.setCustomerOrders(liveStore.currentCustomerRecord.sid, op)

      saveCurrentOrder()
      // let order = toJS(liveStore.currentLiveOrder)
      // let r = updateManyDataRows({
      //   variables: {
      //     input: {
      //       data: {
      //         type: "rowkey",
      //         rows: [order]
      //       }
      //     }
      //   }
      // })

    }
    setCodeSelect(false)
    // if (op[cSelect.index]) {
    //   op[cSelect.index].ref = ref.sid
    //   op[cSelect.index].match_code = cSelect.ref.code

    //   // let pq = liveStore.getItemPriceAndQuanityLive(cSelect.ref.code)
    //   // if (pq) {
    //   //   op[cSelect.index].price = pq.price_live
    //   // }
    //   // // neu ko tim dc price tu live product, lay price cua ref
    //   // if (!op[cSelect.index].price) op[cSelect.index].price = cSelect.ref.price
    //   // op[cSelect.index].match_code = cSelect.ref.code
    //   op[cSelect.index].price = cSelect.ref.price

    //   liveStore.setCustomerOrders(liveStore.currentCustomerRecord.sid, op)
    // }
    // // liveStore.setCustomerOrderItem(liveStore.currentCustomerRecord.sid, op[cSelect.index])
    // // setOrderProducts(op)
    // // console.log(`detailData[cSelect.index]`, detailData[cSelect.index])
    // setCodeSelect(false)
  }

  const saveNewCustomer = (cSelect) => {
    if (!cSelect) return
    if (cSelect.ref) {
      liveStore.currentLiveOrder.customer = {
        name: cSelect.ref.name,
        mobile: cSelect.ref.mobile,
        ref: cSelect.ref
      }
    } else {
      if (liveStore.currentLiveOrder.customer) liveStore.currentLiveOrder.customer.ref = false
    }
  }
  // console.log('detailData', detailData)
  return (
    <LiveDetailContainer>
      <Tabs defaultActiveKey="adjustPane">
        <TabPane
          tab={
            <span><ControlOutlined />Đối chiếu</span>
          }
          key="adjustPane"
        // style={{
        //   height: 'calc(1000px - 200px)'
        // }}
        >

          {liveStore.currentLiveOrder?.code && datatableStore.preloadTable?.status ? ""
            :
            <Button type="primary" shape="round" disabled={liveStore.currentLiveOrder?.items?.length < 1} icon={<ShoppingCartOutlined />} size={'small'}
              onClick={async () => {

                if (liveStore.currentLiveOrder.items.length > 0) {
                  liveStore.currentLiveOrder.items.forEach(item => {
                    if (item.ref)
                      item.ref = {
                        name: item.ref.name,
                        code: item.ref.code,
                        id: item.ref.id,
                        sid: item.ref.sid,
                        image: item.ref.image,
                        price: item.ref.price
                      }
                  });
                }
                let co = liveStore.currentLiveOrder
                co.ngay_tao = (new Date()).toISOString()
                co.live_id = tableId
                co.code = (new Date()).valueOf()
                if (datatableStore.preloadTable?.status)
                  co.status = {
                    ref: datatableStore.preloadTable.status[0]
                  }
                let se = co.code + " " + removeVietnameseCharMark(co.customer?.name)
                if (co.customer?.mobile) se += " " + co.customer?.mobile
                const input = {
                  data: {
                    datatable: commonStore?.company?.companyData?.order_table,
                    row_data: co,
                    rid: commonStore?.company?.companyData?.order_table + '_' + co.sid,
                    se: se
                  }
                }
                try {
                  var newRow = await createDatarow({
                    variables: { input }
                  })
                  if (newRow) {
                    message.success(`Thêm mới đơn hàng thành công!`)
                    liveStore.updateCurrentRecord()
                  } else {
                    message.error(`Thêm mới đơn hàng thất bại!`);
                  }
                } catch (error) {
                }
              }}>
              Tạo đơn
            </Button>
          }
          <PerfectScrollbar
            style={{
              maxHeight: 'calc(100vh - 230px)',
              height: '100vh',
              marginBottom: 10,
            }}>
            {
              liveStore.currentOrderItems ?
                <Table
                  id="adjustTable"
                  style={{
                    border: '1px solid #fcfcfc'
                  }}
                  components={{
                    body: {
                      row: EditableRow,
                      cell: EditableCell,
                    },
                  }}
                  // expandable={{
                  //   expandedRowRender: record => <p style={{ margin: 0 }}>{record.code}</p>,
                  // }}
                  dataSource={liveStore.currentOrderItems}
                  columns={columns}
                  // scroll={{ y: 'calc(100vh - 235px)', scrollToFirstRowOnChange: true }}
                  bordered
                  size={'small'}
                  pagination={false}
                />
                : ""
            }

          </PerfectScrollbar>
        </TabPane>
        <TabPane
          tab={
            <span><ShoppingOutlined />SP đơn hàng</span>
          }
          key="orderPane"
        >
          <LiveOrderPanel table={tableId} />
        </TabPane>
        <TabPane
          tab={
            <span><IdcardOutlined />Thông tin</span>
          }
          key="customerPane"
        >
          <LiveCustomerForm />
          {/* <Space direction="vertical">
            <Space>
              <ContactsFilled
                style={{ fontSize: '32px', color: liveStore.currentLiveOrder?.customer?.ref ? "#03BF68" : "#dddddd" }}
              />
              <Button icon={liveStore.currentLiveOrder?.customer?.ref ? <CheckOutlined /> : <QuestionCircleOutlined />}
                onClick={() => {
                  // setCustomerSelect(liveStore.currentCustomerRecord?.name)
                  let customer = liveStore.currentLiveOrder?.customer
                  let name = (customer ? customer.name : liveStore.currentCustomerRecord?.name)
                  setCustomerSelect({
                    name: name,
                    ref: customer?.ref
                  })
                }}
              >{liveStore.currentCustomerRecord?.name}</Button>
            </Space>
            <Space>
              <PhoneFilled
                style={{ fontSize: '32px', color: liveStore.currentLiveOrder?.customer?.mobile ? "#03BF68" : "#dddddd" }}
              />
              <span>{liveStore.currentLiveOrder?.customer?.mobile}</span>
            </Space>
          </Space> */}
        </TabPane>

      </Tabs>
      {codeSelect ?
        <DataSelectModal
          title={'Chỉnh sửa mã'}
          searchColumns={["code", "name"]}
          displayColumns={["code", "name", "price"]}
          initData={codeSelect}
          // tableId="5fe7fb4d2136a764ac573c1e"
          tableId={commonStore?.company?.companyData?.live_product_table}
          closeOnSelect={true}
          onSave={(v) => {
            // console.log('v', v)
            saveNewCode(v)
          }}
          onClose={() => {
            setCodeSelect(false)
          }}
          // component={ProductItem}
          onSearchSelect={(v, o) => {
            // console.log('o', o)
          }}
        />
        : ""
      }
      {customerSelect ?
        <DataSelectModal
          title={'Chỉnh sửa khách hàng'}
          searchColumns={["name", "mobile"]}
          displayColumns={["name", "mobile"]}
          // searchText={customerSelect}
          initData={customerSelect}
          // tableId="5fe7fb4d2136a764ac573c1e"
          tableId={commonStore?.company?.companyData?.customer_table}
          onSave={(v) => {
            // console.log('cv', v)
            saveNewCustomer(v)
            // save(v)
          }}
          onClose={() => {
            setCustomerSelect(false)
          }}
          // component={ProductItem}
          onSearchSelect={(v, o) => {
            // console.log('o', o)
          }}
        />
        : ""
      }
    </LiveDetailContainer>
  )
}

export default inject("datatableStore", "liveStore", "commonStore")(observer(LiveDetailPanel))